export const initializeWebSocket = () => {
  const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const wsHost = `${wsProtocol}//${window.location.host}`;
  const socket = new WebSocket(wsHost);
  return socket;
}
